/*
countries.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

export const COUNTRY_CODES = [
  {countryCode:'ARGENTINA', regionCode: 'ar'},
  {countryCode:'ARMENIA', regionCode: 'am'},
  {countryCode:'AUSTRALIA', regionCode: 'au'},
  {countryCode:'AZERBAIJAN', regionCode: 'az'},
  {countryCode:'BELARUS', regionCode: 'by'},
  {countryCode:'BELGIUM', regionCode: 'be'},
  {countryCode:'BRAZIL', regionCode: 'br'},
  {countryCode:'CANADA', regionCode: 'ca'},
  {countryCode:'CHILE', regionCode: 'cl'},
  {countryCode:'CHINA', regionCode: 'cn'},
  {countryCode:'COLOMBIA', regionCode: 'co'},
  {countryCode:'CROATIA', regionCode: 'hr'},
  {countryCode:'DENMARK', regionCode: 'dk'},
  {countryCode:'FINLAND', regionCode: 'fi'},
  {countryCode:'FRANCE', regionCode: 'fr'},
  {countryCode:'GERMANY', regionCode: 'de'},
  {countryCode:'HONG_KONG', regionCode: 'hk'},
  {countryCode:'INDIA', regionCode: 'in'},
  {countryCode:'INDONESIA', regionCode: 'id'},
  {countryCode:'IRELAND', regionCode: 'ie'},
  {countryCode:'ISRAEL', regionCode: 'il'},
  {countryCode:'ITALY', regionCode: 'it'},
  {countryCode:'JAPAN', regionCode: 'jp'},
  {countryCode:'KOREA', regionCode: 'kr'},
  {countryCode:'MEXICO', regionCode: 'mx'},
  {countryCode:'NETHERLANDS', regionCode: 'nl'},
  {countryCode:'NEW_ZEALAND', regionCode: 'nz'},
  {countryCode:'NORWAY', regionCode: 'no'},
  {countryCode:'PARAGUAY', regionCode: 'py'},
  {countryCode:'PERU', regionCode: 'pe'},
  {countryCode:'POLAND', regionCode: 'pl'},
  {countryCode:'PORTUGAL', regionCode: 'pt'},
  {countryCode:'RUSSIA', regionCode: 'ru'},
  {countryCode:'SCOTLAND', regionCode: 'gb-sct'},
  {countryCode:'SINGAPORE', regionCode: 'sg'},
  {countryCode:'SOUTH_AFRICA', regionCode: 'za'},
  {countryCode:'SPAIN', regionCode: 'es'},
  {countryCode:'SWEDEN', regionCode: 'se'},
  {countryCode:'SWITZERLAND', regionCode: 'ch'},
  {countryCode:'TAIWAN', regionCode: 'tw'},
  {countryCode:'THAILAND', regionCode: 'th'},
  {countryCode:'TURKEY', regionCode: 'tr'},
  {countryCode:'UK', regionCode: 'gb'},
  {countryCode:'UKRAINE', regionCode: 'ua'},
  {countryCode:'URUGUAY', regionCode: 'uy'},
  {countryCode:'US', regionCode: 'us'},
  {countryCode:'UZBEKISTAN', regionCode: 'uz'},
  {countryCode:'VENEZUELA', regionCode: 've'}
] as const
